import { connect } from 'react-redux'
import _ from 'lodash'
import { EMPTY_VALUE } from '../../../constants/globalTypes'
import styles from './Header.css'
import { HyperLink } from '../../Common/Form'

const Header = (props) => {
  const { page, isHideUserInfo } = props
  const {
    externalSellerLoginUrl,
    user = {}
  } = page
  const { sellerId = EMPTY_VALUE } = user
  const userName = _.get(user, 'id', EMPTY_VALUE)
  const isNotLogin = userName === EMPTY_VALUE
  return (
    <header
      data-role='header'
      className={styles.pageHeader}
    >
      <div className={`navbar ${styles.navbar}`}>
        <nav className={`navbar-color ${styles.navbarColor}`}>
          <div className={`navbar-wrapper ${styles.navbarWrapper}`}>
            <div className={styles.logoWrapper}>
              <a
                data-role='logo-link'
                className={styles.logo}
                href='//tw.buy.yahoo.com'
              >
                <img
                  src='https://img.yec.tw/zq/shp-shared/frontend/201909111712/statics/img/UH@2x.png'
                  alt='logo'
                  width='220px'
                  height='40px'
                />
              </a>
            </div>
            {!isHideUserInfo && (
              <ul className={styles.functionWrapper}>
                <li>
                  {isNotLogin && (
                    <HyperLink href={externalSellerLoginUrl}>
                      登入
                    </HyperLink>
                  )}
                  {!isNotLogin && `${userName}, 您好`}
                </li>
                {!isNotLogin && (
                  <>
                    <li>
                      <HyperLink
                        href={`//tw.buy.yahoo.com/ystore/${sellerId}`}
                      >
                        檢視我的商店首頁
                      </HyperLink>
                    </li>
                    <li>
                      <HyperLink
                        id='logoutBtn'
                        href='/seller/logout'
                      >
                        登出
                      </HyperLink>
                    </li>
                  </>
                )}
              </ul>
            )}
          </div>
        </nav>
      </div>
    </header>
  )
}

const mapStateToProps = (state, ownProps) => {
  const envConf = _.get(state, 'page.envConf', {})
  return {
    page: state.page,
    envConf
  }
}

export default connect(
  mapStateToProps
)(Header)
